import worldMap from '../core/map';

import templates from '../core/templates';
import ColorBrewer from '../core/tools/colorbrewer';
import ColorFlatUI from '../core/tools/colorflatui';
import environment from '../environment';
import Leaflet from './Leaflet';

const LayerControls = (name) => require('../controls').get(name);
const LayerInfo = (name) => require('../info').get(name);

class NewGreenfieldAreasLayer {
    constructor (currentMap) {
        const mapId = currentMap._id;

        const onClick = (feature) => {
            if (worldMap.getCurrent()._id === mapId) {
                const status = LayerInfo('MarkedArea').check(feature.properties.Id) ? 'uncheck' : 'check';
                $(`#MarkedArea-selection-${feature.properties.Id}`).iCheck(status);
            }
        };

        const onComplete = () => {
            const markedAreaControl = LayerControls('MarkedArea');
            if (markedAreaControl.options.types.pma && !markedAreaControl.check() && markedAreaControl.getControls().dropdown.list.input.value() !== markedAreaControl.options.types.pma) {
                markedAreaControl.getControls().dropdown.list.input.select((dataItem) => dataItem.value === markedAreaControl.options.types.pma.id);
                markedAreaControl.getControls().dropdown.data.text =  markedAreaControl.getControls().dropdown.list.input.text();
                markedAreaControl.getControls().dropdown.data.value =  markedAreaControl.getControls().dropdown.list.input.value();
                const options = {
                    remote: {
                        method: 'GET',
                        url: `${environment.get('API_HOST')}/localidade/GetLocation`,
                        params: {
                            locationType: markedAreaControl.options.types.pma.id
                        }
                    }
                };
                markedAreaControl.select(markedAreaControl.options.types.pma.id, options);
            }
        };

        return new Leaflet.D3Layer({
            map: currentMap,
            remote: {
                url: `${environment.get('API_HOST')}/localidade/GetLocation`,
                params: {
                    // TODO: (2023-05-22) CHANGE THIS WITH MODEL LocalidadeFuncionalidade
                    // workaround pmas for client GM
                    locationType: (environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES').pma || environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES').pmaAjustada).id,
                    format: 'topojson'
                }
            },
            cache: false,
            filter: {
                location: true
            },
            showAll: false,
            expandView: 0.3,
            autofocus: false,
            scaleRange: [4, 18],
            uniqueField: 'Id',
            sort: 'Nome',
            below: true,
            dblclick: onClick,
            label: {
                template (properties) {
                    return templates('map-layer-areas-label', properties);
                },
                options: {
                    offset: [12, -40],
                    direction: 'right'
                }
            },
            done: onComplete,
            value: 'Nome',
            symbology: {
                type: 'choropleth',
                scale: 'nomenal',
                theme: ColorBrewer.Set3['12'],
                style: {
                    highlight: true,
                    lineJoin: 'round',
                    color: ColorFlatUI.wet_asphalt[1][0],
                    fillColor: 'rgba(0,0,0,0.1)',
                    fillOpacity: 0.4,
                    opacity: 1,
                    weight: 1.2
                }
            }
        });
    }
}

export default NewGreenfieldAreasLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/NewGreenfieldAreasLayer.js